import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import React from 'react';
import './Tags.scss';

export type Tag = {
    link: string;
    text: string;
    tracking_action: string;
    tracking_category: string;
};

export const Tags = ({ tags }: { tags: Array<Tag> }) => {
    if (!tags?.length) {
        return null;
    }

    return (
        <section aria-labelledby="tags-heading">
            <div className="eds-l-mar-bot-12">
                <h3 id="tags-heading" className="label-primary">
                    {gettext('Tags')}
                </h3>
                <ul>
                    {tags
                        .filter((tag: Tag) => !!tag?.link)
                        .map((tag: Tag, index) => (
                            <li key={index} className="tags-item inline">
                                <a
                                    href={tag.link}
                                    className="tags-link listing-tag eds-l-mar-top-4 eds-text-bs eds-text--center"
                                    onClick={() =>
                                        trackAnalyticsEvent({
                                            category: tag.tracking_category,
                                            action: tag.tracking_action,
                                            label: tag.link,
                                        })
                                    }
                                >
                                    {tag.text}
                                </a>
                            </li>
                        ))}
                </ul>
            </div>
        </section>
    );
};
